<template>
  <div class="admin">
    <el-container>
      <el-header class="py-8 flex flex-wrap items-center justify-between bg-grey-lightest">
        <div>
          <h1 class="text-blue">{{ routerName }}</h1>
        </div>
        <div class="flex items-center" v-if="user">
          <div class="mr-8 text-grey">user</div>
          <div class="font-bold text-blue mr-8">{{ user.username }}</div>
          <el-button size="mini" @click="userLogout">登出</el-button>
        </div>
      </el-header>
      <el-main>
        <router-view></router-view>
      </el-main>
    </el-container>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
export default {
  beforeMount () {
    if (!this.user) {
      this.$router.replace({
        name: 'login'
      })
    }
  },
  data () {
    return {
    }
  },
  computed: {
    ...mapGetters([
      'token',
      'user'
    ]),
    routerName: function () {
      return this.$route.name
    }
  },
  methods: {
    ...mapActions([
      'userLogout'
    ])
  }
}
</script>

<style>

</style>
